<div class="p-4">
	<div class="demo-container">
    	<div class="title">Expired Documents</div>
    	<button
			type="button"
			class="btn btn-primary btn-sm"
			(click)="safetyChecklistCheckAboutToExpiredDocs()"
        	*ngIf="!isSafteyChecklistExpiredRunning" data-testid="safety-check-about-to-expire">
			Check about to expire documents (WIP)
		</button>
		<button
			type="button"
			class="btn btn-primary btn-sm"
			(click)="safetyChecklistCheckExpiredDocs()"
        	*ngIf="!isSafteyChecklistExpiredRunning" data-testid="safety-check-expired-documents">
			Check expired documents
		</button>
    	<i
			class="fa-solid fa-sword fa-spin ml-5 pl-5 text-warning"
			*ngIf="isSafteyChecklistExpiredRunning"></i
		><i
			class="fa-solid fa-axe-battle fa-spin fa-spin-reverse pr-5 text-danger"
			*ngIf="isSafteyChecklistExpiredRunning"></i>
	</div>
</div>


// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/safety/safety.component.html